import { useRefreshAccessTokenRider, useRefreshAccessTokenDriver } from "./useAuthMutations";
import { useAuthStore, useUserStore } from '../../stores';

export const useRefreshToken = () => {
  // Global state.
  const { setAccessToken } = useAuthStore();
  const { userType } = useUserStore();

  // Get refresh access token mutations.
  const {refreshAccessTokenRider} = useRefreshAccessTokenRider();
  const {refreshAccessTokenDriver} = useRefreshAccessTokenDriver();

   const handleRefresh = async () => {
    if (!userType) return;

    try {
      if (userType === 'rider') {
        const { data } = await refreshAccessTokenRider();
        setAccessToken(data.refreshAccessTokenRider.accessToken);
      } else if (userType === 'driver') {
        const { data } = await refreshAccessTokenDriver();
        setAccessToken(data.refreshAccessTokenDriver.accessToken);
      }
    } catch (error) {
      // Refresh failed - user will need to log in again
    }
  };

  return handleRefresh;
};
